import React from 'react';
import './index.less';

export default class NoPermission extends React.Component {
    static defaultProps = {
        text: (window._lang || UG.lang).template('该地区暂未开放')
    };

    render() {
        return (
            <div className="no-permission">
                {this.props.text}
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/host/noperm/index.js